module.exports = function getResource(label, vars = []) {
    const resources = {
        item: 'ITEM',
        items: 'items',
        qty: 'QTY',
        basketSubtotal: 'Basket Subtotal',
        subTotal: 'Subtotal',
        continue: 'Continue Shopping',
        seeSamples: 'See samples, rewards and promotions in',
        basket: 'basket',
        standardTitle: 'Added to Basket for Standard Shipping',
        sddTitle: 'Added to Basket for Same-Day Delivery',
        reserveTitle: `Added to Basket for Pickup at ${vars[0]}`,
        autoReplenishTitle: 'Item added to Auto-Replenish',
        proceedToBasket: 'Proceed to Basket',
        viewInBasket: 'View in Basket',
        viewAndCheckout: 'View Basket & Checkout',
        viewAndReserve: 'View Basket & Reserve',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testSeeDetails: 'See details',
        testCardDiscount: `Save ${vars[0]} off your Sephora order when you open and use your Sephora Credit Card.`,
        testCardDiscountTitle: 'Open a Sephora Credit Card Today',
        mostCommon: 'most common',
        deliverEvery: 'Deliver every',
        weeksShort: 'wks.',
        monthsShort: 'mo.'
    };

    return resources[label];
};
